import { useAppDispatch } from "store";
import { sandboxActionCompleted } from "store/features";
import { EmbedDialog } from "./EmbedDialog";

interface EmbedSandboxActionHandlerProps {
  userName?: string;
  sandboxName?: string;
}

export const EmbedSandboxActionHandler = ({ userName, sandboxName }: EmbedSandboxActionHandlerProps) => {
  const dispatch = useAppDispatch();

  const onClose = () => {
    dispatch(sandboxActionCompleted());
  };

  if (!userName || !sandboxName)
    return null;

  return (
    <EmbedDialog codeShare={sandboxName} username={userName} onClose={onClose} />
  )
};